<template>
  <div class="signup">
    <h2>新規登録</h2>
    <input type="text" placeholder="メールアドレス" v-model="email">
    <input type="password" placeholder="パスワード" v-model="password">
    <button @click="signUp">登録</button>
    <p>アカウントをお持ちですか?
      <router-link to="/login">ログインする</router-link>
    </p>
  </div>
</template>

<script>
  //import {auth} from '../firebase'
  //import firebase from 'firebase/auth'
  //import * as firebase from 'firebase/app'
  import {auth} from '../firebase'

  export default {
    name: 'Signup',
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      signUp: function () {
        auth.createUserWithEmailAndPassword(this.email, this.password)
          .then(user => {
            alert('Create account: ', user.email)
            this.$router.push('/list')
          })
          .catch(error => {
            alert(error.message)
          })
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .signup {
    margin-top: 20px;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center
  }
  input {
    margin: 10px 0;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Signup.vue